import { save } from '@tauri-apps/plugin-dialog';
import { writeFile } from '@tauri-apps/plugin-fs';
import {
    isTauriEnvironment as detectTauriEnvironment,
    openExternalUrl as openUrlWithTauri
} from '../utils/tauri';

export const isTauriEnvironment = detectTauriEnvironment;
export const openExternalUrl = openUrlWithTauri;

export const getFileExtension = (filename) => {
    const ext = filename?.split('.').pop();
    return ext && ext !== filename ? ext : '';
};

export const downloadBlobInBrowser = (blob, filename) => {
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
};

export const triggerUrlDownload = (url, filename) => {
    if (!url || typeof document === 'undefined') {
        return false;
    }

    const link = document.createElement('a');
    link.href = url;
    if (filename) {
        link.download = filename;
    }
    link.rel = 'noopener noreferrer';
    link.style.display = 'none';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return true;
};

export const saveBlobWithTauri = async (blob, filename) => {
    const extension = getFileExtension(filename);
    const saveOptions = {
        defaultPath: filename
    };

    if (extension) {
        saveOptions.filters = [
            {
                name: extension.toUpperCase(),
                extensions: [extension]
            }
        ];
    }

    const savePath = await save(saveOptions);
    if (!savePath) {
        return false;
    }

    const arrayBuffer = await blob.arrayBuffer();
    await writeFile(savePath, new Uint8Array(arrayBuffer));
    return true;
};
